import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "versus-teams d-flex flex-justify-center flex-items-center my-5"
}
const _hoisted_3 = { class: "team d-sm-flex flex-justify-center flex-items-center flex-row-reverse py-5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "team-name mr-sm-5" }
const _hoisted_6 = { class: "versus-text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "px-1 px-sm-4" }, "-", -1)
const _hoisted_8 = {
  key: 0,
  class: "team d-sm-flex flex-justify-center flex-items-center py-5"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "team-name ml-sm-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.team1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.team1.avatar !== null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "img-circle img-circle-bordered",
                  src: _ctx.team1.avatar.url
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.team1.name), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.game.team1Score), 1),
            _hoisted_7,
            _createTextVNode(_toDisplayString(_ctx.game.team2Score), 1)
          ]),
          (_ctx.team2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.team2.avatar !== null)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "img-circle img-circle-bordered",
                      src: _ctx.team2.avatar.url
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.team2.name), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}